import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { RecipientsApi, RestApiError, type RecipientCreateRequest, type RecipientResponse } from '@shared/api';

const createRecipientEffect = createEffect((request: RecipientCreateRequest) => RecipientsApi.createRecipient(request));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(createRecipientEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(createRecipientEffect.pending, (_, data) => data)
  .on(createRecipientEffect.fail, () => false)
  .on(createRecipientEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(createRecipientEffect, () => null)
  // .on(createRecipientEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(createRecipientEffect.fail, (_, data) => {
    if (RestApiError.isRestApiError(data.error) && data.error.data.errorCode) return data.error.message;
    return 'Something went wrong while creating Recipient. Please try again.';
  })
  .on(createRecipientEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $recipientCreateStore = {
  events: {
    createRecipient: createRecipientEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
